import BasePlugin from './base-plugin'
import { vjs_El, vjs_find, vjs_mfind } from './utils'

class SettingsMenuPlugin extends BasePlugin {
  constructor(player) {
    super(player)

    player.on('settings:showSubMenu', (e, name) => {
      this.showSubMenu(name)
    })

    player.on('playerresize', () => {
      this.resetMenus()
    })

    this.menuSizes = {}
    this.subMenuElsByName = {}
    this.settingsMenuComp = this.player.ControlBarPlugin().addButton(this.dom.createEl(
      'button',
      {
        className:
          'vjs-control vjs-button vjs-cog-button vjs-cog-menu-button',
      },
      {
        'role': 'button',
        'type': 'button',
        'aria-haspopup': 'true',
        'aria-live': 'off',
        'aria-disabled': 'false',
        'aria-expanded': 'false',
        'aria-label': 'Settings menu',
      },
    ))
    this.settingsMenuEl = this.settingsMenuComp.el()
    this.settingsMenuEl.innerHTML = '<span aria-hidden="true" class="vjs-icon-placeholder" data-id="settings"></span><span class="vjs-control-text" aria-live="polite">Settings</span>'
    this.menuSettingsEl = vjs_El('div', 'vjs-menu-settings')
    this.settingsDivEl = vjs_El('div', 'vjs-menu-div vjs-settings-div')
    this.menuSettingsEl.appendChild(this.settingsDivEl)
    this.settingsHomeMenuEl = vjs_El('div', 'vjs-submenu vjs-settings-home', '<div class="vjs-menu-title">Settings</div>')
    this.mainMenuUlEl = vjs_El('ul', 'vjs-menu-content vjs-settings-list')
    this.mainMenuUlEl.role = 'menu'
    this.settingsHomeMenuEl.appendChild(this.mainMenuUlEl)
    this.settingsDivEl.appendChild(this.settingsHomeMenuEl)
    this.settingsMenuEl.appendChild(this.menuSettingsEl)

    this.settingsMenuEl.onclick = this.settingsMenuEl.ontouchend = (event) => {
      event.preventDefault()
      event.stopPropagation()
      if (!vjs_find(this.playerElement, '.vjs-tech-chromecast')) {
        this.resetMenus()
        if (this.dom.hasClass(this.menuSettingsEl, 'vjs-lock-showing') !== true) {
          event.target.ariaExpanded = 'true'
          this.player.trigger('controlClick', event.target)
          this.dom.addClass(this.menuSettingsEl, 'vjs-lock-showing')
          vjs_find(this.settingsMenuEl, '.vjs-control-text').style.opacity = 0
          this.dom.addClass(event.target, 'vjs-cog-active')
          this.dom.removeClass(this.menuSettingsEl, this.hiddenClass)
          this.dom.removeClass(this.settingsHomeMenuEl, this.hiddenClass)
          this.settingsDivEl.style.width = `${this.menuSizes.cogMenu.width}px`
          this.settingsDivEl.style.height = `${this.menuSizes.cogMenu.height}px`
        }
        else {
          this.hideAll()
        }
      }
    }
    this.settingsMenuEl.onmouseover = () => {
      if (this.dom.hasClass(this.menuSettingsEl, 'vjs-lock-showing') !== true) {
        vjs_find(this.settingsMenuEl, '.vjs-control-text').removeAttribute('style')
      }
    }

    this.player.on('controlClick', (e, el) => {
      if (!this.dom.hasClass(el, 'vjs-settings-item')) {
        this.hideAll()
      }
    })
  }

  showSubMenu(name) {
    this.dom.addClass(this.settingsHomeMenuEl, this.hiddenClass)
    this.dom.removeClass(this.subMenuElsByName[name], this.hiddenClass)
    setTimeout(() => {
      this.settingsDivEl.style.width = `${this.menuSizes[name].width}px`
      this.settingsDivEl.style.height = `${this.menuSizes[name].height}px`
    }, 10)
  }

  hideAll() {
    const submenus = vjs_mfind(this.playerElement, '.vjs-submenu')
    for (let t = 0; t < submenus.length; t++) {
      this.dom.addClass(submenus[t], this.hiddenClass)
      if (submenus[t] === this.settingsHomeMenuEl) {
        this.dom.removeClass(this.settingsHomeMenuEl, this.hiddenClass)
      }
    }
    this.dom.removeClass(this.menuSettingsEl, 'vjs-lock-showing')
    this.dom.addClass(this.menuSettingsEl, this.hiddenClass)
    this.settingsMenuEl.ariaExpanded = 'false'
    this.dom.removeClass(this.settingsMenuEl, 'vjs-cog-active')
  }

  showMainMenu() {
    Object.keys(this.subMenuElsByName).forEach((name) => {
      this.dom.addClass(this.subMenuElsByName[name], this.hiddenClass)
    })
    this.dom.removeClass(this.settingsHomeMenuEl, this.hiddenClass)
    this.settingsDivEl.style.width = `${this.menuSizes.cogMenu.width}px`
    this.settingsDivEl.style.height = `${this.menuSizes.cogMenu.height}px`
  }

  resetMenus() {
    this.settingsDivEl.style.width = 'auto'
    this.settingsDivEl.style.height = 'auto'
    this.dom.removeClass(this.menuSettingsEl, this.hiddenClass)
    this.menuSizes.cogMenu = { width: this.menuSettingsEl.clientWidth, height: this.menuSettingsEl.clientHeight }
    Object.keys(this.subMenuElsByName).forEach((name) => {
      const subMenuEl = this.subMenuElsByName[name]
      this.dom.addClass(subMenuEl, this.hiddenClass)
      this.dom.addClass(this.settingsHomeMenuEl, this.hiddenClass)
      Object.keys(this.subMenuElsByName).forEach((item) => {
        if (item !== name) {
          this.dom.addClass(this.subMenuElsByName[item], this.hiddenClass)
        }
      })
      this.dom.removeClass(subMenuEl, this.hiddenClass)
      this.dom.addClass(subMenuEl, 'vjs-invisible')
      this.menuSizes[name] = { width: subMenuEl.clientWidth, height: subMenuEl.clientHeight }
      this.dom.removeClass(subMenuEl, 'vjs-invisible')
      this.dom.addClass(subMenuEl, this.hiddenClass)
    })
    Object.keys(this.subMenuElsByName).forEach((name) => {
      this.dom.addClass(this.subMenuElsByName[name], this.hiddenClass)
    })

    this.dom.removeClass(this.settingsHomeMenuEl, this.hiddenClass)
    this.dom.removeClass(this.menuSettingsEl, 'vjs-invisible')
    this.dom.removeClass(this.settingsHomeMenuEl, this.hiddenClass)
    const r = this.settingsDivEl.getBoundingClientRect()
    const v = this.playerElement.getBoundingClientRect()
    const f = this.playerElement.offsetHeight - (v.bottom - r.bottom)
    this.settingsDivEl.style.maxHeight = `${f}px`
  }

  addMenu(name, mainMenuItemEl, subMenuEl) {
    this.mainMenuUlEl.appendChild(mainMenuItemEl)
    if (subMenuEl) {
      this.settingsDivEl.appendChild(subMenuEl)
      this.subMenuElsByName[name] = subMenuEl
      vjs_find(subMenuEl, '.vjs-settings-back').onclick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.showMainMenu()
      }
    }
    this.resetMenus()
  }
}

export default SettingsMenuPlugin
